import React, { useState } from "react";
import { Button, Datepicker } from "flowbite-react";
import type { DateRange } from "..";

interface DateRangePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (range: DateRange) => void;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onChange,
}) => {
  const [tempRange, setTempRange] = useState<DateRange>({
    start: startDate,
    end: endDate,
  });

  const maxDate = new Date();

  const handleApply = () => {
    if (tempRange.start && tempRange.end && tempRange.start > tempRange.end) {
      // Swap dates if start is after end
      onChange({
        start: tempRange.end,
        end: tempRange.start,
      });
    } else {
      onChange(tempRange);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Datepicker
        value={tempRange.start?.toString()}
        onSelectedDateChanged={(date) =>
          setTempRange((prev) => ({ ...prev, start: date }))
        }
        placeholder="Start date"
        maxDate={maxDate}
      />
      <span className="text-gray-500">to</span>
      <Datepicker
        value={tempRange.end?.toString()}
        onSelectedDateChanged={(date) =>
          setTempRange((prev) => ({ ...prev, end: date }))
        }
        placeholder="End date"
        maxDate={maxDate}
        minDate={tempRange.start || undefined}
      />
      <Button
        size="sm"
        onClick={handleApply}
        disabled={!tempRange.start || !tempRange.end}
      >
        Apply Dates
      </Button>
    </div>
  );
};
